import React, { useState, useRef } from 'react';
import '../styles/ActionInput.css';
import SYMBOLS from '../utils/symbols';

const ActionInput = ({
  onSubmit,
  disabled = false,
  placeholder = "What do you do?",
  isLoading = false
}) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim() && !disabled) {
      onSubmit(value.trim());
      setValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      handleSubmit(e);
    }
  };

  return (
    <div className={`action-input-container ${disabled ? 'disabled' : ''} ${isLoading ? 'loading' : ''}`}>
      {/* Decorative comic elements */}
      <div className="input-decoration top-left"></div>
      <div className="input-decoration top-right"></div>
      <div className="input-decoration bottom-left"></div>
      <div className="input-decoration bottom-right"></div>

      <form onSubmit={handleSubmit} className="action-form">
        {/* Label styled as comic caption */}
        <label htmlFor="action-input" className="action-label">
          <span className="label-text">YOUR NEXT MOVE</span>
          <span className="label-arrow">{SYMBOLS.TRIANGLE_DOWN}</span>
        </label>

        <div className="input-wrapper">
          <input
            ref={inputRef}
            id="action-input"
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            className="action-input"
            autoComplete="off"
            spellCheck="true"
          />

          <button
            type="submit"
            disabled={disabled || !value.trim()}
            className="action-button"
            aria-label="Take action"
          >
            {isLoading ? (
              <span className="button-loading">
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
              </span>
            ) : (
              <>
                <span className="button-text">GO!</span>
                <span className="button-icon">{SYMBOLS.ARROW_RIGHT}</span>
              </>
            )}
          </button>
        </div>

        {/* Help text */}
        <div className="input-help">
          <span className="help-text">
            {isLoading 
              ? "The story unfolds..." 
              : "Describe your action. Be bold, be clever!"
            }
          </span>
        </div>
      </form>

      {/* Loading bar at bottom */}
      {isLoading && (
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>
      )}
    </div>
  );
};

export default ActionInput;